import React, { Component } from "react";
import { Session } from "../pages/Dashboard";
import StackedBarChart from "./charts/StackedBarChart";

type Props = {
  sessions: Session[];
  loading: boolean;
};
type State = {};
export default class GamesPlayedChart extends Component<Props, State> {
  processData = () => {
    // Bucket by monthly timestamp directly (built with the multi-arg Date
    // constructor so it's portable across browsers — Firefox is strict about
    // ISO date strings and rejects unpadded months like "2025-3").
    const gamesPlayed: { [gameName: string]: { [timestamp: number]: number } } =
      {};
    this.props.sessions.forEach((session) => {
      if (!session.timestamp || !session.game) return;
      const parts = session.timestamp.split("-");
      if (parts.length < 2) return;
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      if (isNaN(year) || isNaN(month) || month < 1 || month > 12) return;

      const ts = new Date(year, month - 1, 1).getTime();
      if (isNaN(ts)) return;

      gamesPlayed[session.game] = gamesPlayed[session.game] || {};
      gamesPlayed[session.game][ts] = gamesPlayed[session.game][ts] || 0;
      gamesPlayed[session.game][ts]++;
    });
    const chartData: { [gameName: string]: { x: number; y: number }[] } = {};
    for (const [gameName, value] of Object.entries(gamesPlayed)) {
      for (const [tsStr, gameCount] of Object.entries(value)) {
        const ts = Number(tsStr);
        if (isNaN(ts)) continue;
        chartData[gameName] = chartData[gameName] || [];
        chartData[gameName].push({ x: ts, y: gameCount });
      }
    }
    return chartData;
  };
  render() {
    return (
      <StackedBarChart loading={this.props.loading} data={this.processData()} />
    );
  }
}
